import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { getHostAndHostessMasterList_action, insertUpdateHostAndHostessMaster_action, deleteHostAndHostessMaster_action } from '../../../../../actions/admin_module_action/master_action/manual_form_master_action/host_and_hostess_master_action'
import { toastError, toastSuccess } from "../../../../../utils/constants";
import Modal from "react-modal";
import Footer from "../../../../../common_components/Footer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";


class HostAndHostessMasterList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            RatesList: [],
            ContactBankList: [],
            deleteID: '',
            deleteType: '',
        }
        this.getHostAndHostessMasterList = this.getHostAndHostessMasterList.bind(this)
        this.deleteHostAndHostessMaster = this.deleteHostAndHostessMaster.bind(this)
        this.handleAdd = this.handleAdd.bind(this)
        this.onDelete = this.onDelete.bind(this)
    }

    componentDidMount() {
        this.getHostAndHostessMasterList()
    }

    getHostAndHostessMasterList() {
        this.setState({ isLoading: true })
        this.props.getHostAndHostessMasterList_action()
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        RatesList: data.data.rates ? data.data.rates : [],
                        ContactBankList: data.data.contactBankList ? data.data.contactBankList : [],
                        isLoading: false,
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    deleteHostAndHostessMaster(id) {
        const { deleteType } = this.state
        this.setState({ isLoading: true })
        this.props.deleteHostAndHostessMaster_action(deleteType == 2 ? id : '', deleteType == 1 ? id : '')
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false, deleteType: '' })
                    toastSuccess("Deleted successfully")
                    setTimeout(() => {
                        this.getHostAndHostessMasterList()
                    }, 200);
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
                this.setState({ isOpen: false })
            })
            .catch((err) => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    handleAdd(status) {
        this.props.navigate('/hostAndHostessMaster', { state: { status: status } })
    }

    onDelete(id, deleteType) {
        this.setState({ deleteID: id, deleteType: deleteType, isOpen: true })
    }

    render() {
        const { isLoading, isOpen, RatesList, ContactBankList } = this.state
        return (
            <>
                {isLoading ? <Loader /> : null}
                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">Host and Hostess Master</h6>
                            </div>
                        </div>
                        <div className="admin-top-space p-2 px-0">
                            <div className="row m-0">
                                <div className="table-responsive">
                                    <div className="card-header p-2" style={{ paddingLeft: "7px !important" }}>
                                        <h3 className="card-title" style={{ fontSize: 15 }}>
                                            Rate Configuration
                                        </h3>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                                            <thead>
                                                <tr>
                                                    <th className="text-center">Host Rate (INR)</th>
                                                    <th className="text-center">Host Rate (USD)</th>
                                                    <th className="text-center">Hostess Rate (INR)</th>
                                                    <th className="text-center">Hostess Rate (USD)</th>
                                                    <th style={{ width: '60px' }} className="text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    RatesList.length > 0 ? (RatesList.map((data, i) => (
                                                        <tr key={i}>
                                                            <td className="text-center">{data.HostRateINR}</td>
                                                            <td className="text-center">{data.HostRateUSD}</td>
                                                            <td className="text-center">{data.HostessRateINR}</td>
                                                            <td className="text-center">{data.HostessRateUSD}</td>
                                                            <td className="text-center">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-outline-danger btn-sm border-0"
                                                                    onClick={() => this.onDelete(data.MstHostAndHostessRateID, 2)}
                                                                >
                                                                    <i className="fa fa-trash action_btn_table" />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))) : <tr><td className="text-center" colSpan={5}>No record found</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="text-end mt-2">
                                        <button
                                            type="button"
                                            className="btn btn-aqua"
                                            onClick={() => this.handleAdd(2)}
                                        >
                                            Add
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row m-0">
                            <div className="table-responsive">
                                <div className="card-header p-2" style={{ paddingLeft: "7px !important" }}>
                                    <h3 className="card-title" style={{ fontSize: 15 }}>
                                        Agency Contact and Bank Details
                                    </h3>
                                </div>
                                <div className="table-responsive">
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                                        <thead>
                                            <tr>
                                                <th className="text-center">Name</th>
                                                <th className="text-center">Address</th>
                                                <th className="text-center">Telephone</th>
                                                <th className="text-center">Mobile</th>
                                                <th className="text-center">Fax</th>
                                                <th className="text-center">Primary Email</th>
                                                <th className="text-center">Secondary Email</th>
                                                <th className="text-center">Bank Name</th>
                                                <th className="text-center">Beneficiary Name</th>
                                                <th className="text-center">Beneficiary Address</th>
                                                <th className="text-center">Account Number</th>
                                                <th className="text-center">Swift Code</th>
                                                <th className="text-center">IFSC Code</th>
                                                <th className="text-center">PAN Number</th>
                                                <th className="text-center">GST Number</th>
                                                <th style={{ width: '60px' }} className="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                ContactBankList.length > 0 ? (ContactBankList.map((data, i) => (
                                                    <tr key={data.MstHostAndHostessContactBankID}>
                                                        <td className="text-center">{data.Name}</td>
                                                        <td className="text-center">{data.Address}</td>
                                                        <td className="text-center">{data.Phone}</td>
                                                        <td className="text-center">{data.Mobile}</td>
                                                        <td className="text-center">{data.Fax}</td>
                                                        <td className="text-center">{data.PrimaryEmail}</td>
                                                        <td className="text-center">{data.SecondaryEmail}</td>
                                                        <td className="text-center">{data.BankName}</td>
                                                        <td className="text-center">{data.BeneficiaryName}</td>
                                                        <td className="text-center">{data.BeneficiaryAddress}</td>
                                                        <td className="text-center">{data.AccountNumber}</td>
                                                        <td className="text-center">{data.SwiftCode}</td>
                                                        <td className="text-center">{data.IFSCCode}</td>
                                                        <td className="text-center">{data.PAN}</td>
                                                        <td className="text-center">{data.GST}</td>
                                                        <td className="text-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-primary btn-sm border-0"
                                                                onClick={() => this.props.navigate('/hostAndHostessMaster', { state: { status: 1, editData: data } })}
                                                            >
                                                                <i className="fa fa-pencil action_btn_table" />
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-danger btn-sm border-0"
                                                                onClick={() => this.onDelete(data.MstHostAndHostessContactBankID, 1)}
                                                            >
                                                                <i className="fa fa-trash action_btn_table" />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))) : <tr><td className="text-center" colSpan={16}>No record found</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="text-end">
                                    <button
                                        type="button"
                                        className="btn btn-aqua mt-2"
                                        onClick={() => this.handleAdd(1)}
                                    >
                                        Add
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title">Do you really want to delete this record?</h5>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop"
                                        onClick={() => this.deleteHostAndHostessMaster(this.state.deleteID)}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Footer />
            </>
        )
    }
}

export default withRouter(connect(null, { getHostAndHostessMasterList_action, insertUpdateHostAndHostessMaster_action, deleteHostAndHostessMaster_action })(HostAndHostessMasterList))
